var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"x-small":"","color":"red","text-color":"white","disabled":"","label":""}},[_c('span',[_vm._v("必須")])])}
var staticRenderFns = []

export { render, staticRenderFns }